module.exports = __webpack_public_path__ + "img/tailwindcss.1f2a3181.png";